import { useEffect, useRef, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ApiError, apiAction } from '../lib/api';

type Status = { kind: 'working' } | { kind: 'success' } | { kind: 'error'; message: string };

export default function Verify({ onVerified }: { onVerified: () => void }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState<Status>({ kind: 'working' });
  const ran = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus({ kind: 'error', message: 'Missing token' });
      return;
    }
    // StrictMode fires effects twice in dev — guard so we only consume the token once.
    if (ran.current) return;
    ran.current = true;

    apiAction('/api/auth/verify', { token })
      .then(() => {
        setStatus({ kind: 'success' });
        onVerified();
      })
      .catch((err) => {
        const message = err instanceof ApiError ? err.message : 'Could not verify link';
        setStatus({ kind: 'error', message });
      });
  }, [token, onVerified]);

  if (status.kind === 'success') return <Navigate to="/" replace />;

  return (
    <div className="login-shell">
      <div className="card login-card">
        {status.kind === 'working' ? (
          <>
            <h1>Signing you in…</h1>
            <p className="subtle">One moment.</p>
          </>
        ) : (
          <>
            <h1>Can't sign in</h1>
            <p className="subtle">{status.message}</p>
            <p style={{ marginTop: 16 }}>
              <a href="/login">Try again</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
